export const backupPlayers = [
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'bernard-arnault',
    bio: '',
    rank: 1,
    listUri: 'rtb',
    finalWorth: 236620.981,
    person: {
      name: 'Bernard Arnault & family',
      uri: 'bernard-arnault',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5dc05518ca425400079c659f/416x416.jpg?background=000000&cropX1=0&cropX2=4000&cropY1=1209&cropY2=5212',
    },
    visible: true,
    personName: 'Bernard Arnault & family',
    city: 'Paris',
    source: 'LVMH',
    industries: ['Fashion & Retail'],
    countryOfCitizenship: 'France',
    timestamp: 1681767302142,
    version: 734362,
    naturalId: 'faris/35/0/4800',
    position: 1,
    imageExists: true,
    gender: 'M',
    birthDate: -657244800000,
    lastName: 'Arnault',
    financialAssets: [
      {
        exchange: 'EURONEXT PARIS',
        ticker: 'CA-FR',
        companyName: 'Carrefour S.A.',
        numberOfShares: 0,
        sharePrice: 20.54485415520088,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'EURONEXT PARIS',
        ticker: 'RMS-FR',
        companyName: 'Hermes International S.C.A.',
        numberOfShares: 1974000,
        sharePrice: 2173.913043478261,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'EURONEXT PARIS',
        ticker: 'MC-FR',
        companyName: 'LVMH Moet Hennessy Louis Vuitton',
        numberOfShares: 237686674,
        sharePrice: 982.7187671986791,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 241725.017196,
    privateAssetsWorth: 3854.557595,
    familyList: false,
    interactive: false,
    archivedWorth: 211000,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5dc05518ca425400079c659f/416x416.jpg?background=000000&cropX1=0&cropX2=4000&cropY1=1209&cropY2=5212',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Bernard Arnault oversees the LVMH empire of 75 fashion and cosmetics brands, including Louis Vuitton and Sephora.',
      'In January 2021, LVMH acquired American jeweler Tiffany & Co for $15.8 billion, believed to be the biggest luxury brand acquisition ever.',
      "Arnault's holding company Agache backs venture capital firm Aglaé Ventures, which has investments in companies such as TikTok parent ByteDance and Netflix.",
      'His father made a small fortune in construction; Arnault got his start by putting up $15 million from that business to buy Christian Dior in 1984.',
      "Arnault's five children all work at LVMH; in July 2022, he proposed a reorganization of his holding company Agache to give them equal stakes",
    ],
    abouts: [
      'Arnault apparently wooed his wife, Helene Mercier, a concert pianist, by playing Chopin and other classical composers on the piano.',
      'Arnault and LVMH own a 40% stake in private equity firm L Catterton, which has $30 billion in assets including investments in Birkenstock and Equinox. ',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'elon-musk',
    bio: '',
    rank: 2,
    listUri: 'rtb',
    finalWorth: 189213.291,
    person: {
      name: 'Elon Musk',
      uri: 'elon-musk',
      imageExists: true,
      squareImage:
        'https://specials-images.forbesimg.com/imageserve/62d700cd6094d2c180f269b9/416x416.jpg?background=000000&cropX1=0&cropX2=959&cropY1=0&cropY2=959',
    },
    visible: true,
    personName: 'Elon Musk',
    state: 'Texas',
    city: 'Austin',
    source: 'Tesla, SpaceX',
    industries: ['Automotive'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734433,
    naturalId: 'faris/35/0/14117',
    position: 2,
    imageExists: true,
    gender: 'M',
    birthDate: 46915200000,
    lastName: 'Musk',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 344161356,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 187.04,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 0,
        exerciseOptionPrice: 6.24,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 304000000,
        exerciseOptionPrice: 23.33666666666667,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 6000,
        exerciseOptionPrice: 2.7886666666666664,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 6000,
        exerciseOptionPrice: 6.670000000000001,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 187891.017441,
    privateAssetsWorth: 75073.35,
    familyList: false,
    interactive: true,
    archivedWorth: 180000,
    thumbnail:
      'http://specials-images.forbesimg.com/imageserve/62d700cd6094d2c180f269b9/280x425.jpg?fit=scale&background=000000',
    squareImage:
      'https://specials-images.forbesimg.com/imageserve/62d700cd6094d2c180f269b9/416x416.jpg?background=000000&cropX1=0&cropX2=959&cropY1=0&cropY2=959',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Elon Musk cofounded six companies including electric car maker Tesla, rocket producer SpaceX and tunneling startup Boring Company.',
      'He owns about 23% of Tesla between stock and options, but has pledged more than half his stock as collateral for loans.',
      'SpaceX, founded in 2002, is worth $127 billion after a funding round in May 2022; it quadrupled its value in three years.',
      'Boring Company, which aims to defeat traffic, raised $675 million in April 2022 at a $5.7 billion valuation.',
      "Twitter's board agreed to sell the company to Musk for $44 billion in April 2022, after he disclosed a 9.1% stake and threatened a hostile takeover.",
      'The deal closed in October 2022 after Musk tried to back out and Twitter sued. Musk now owns an estimated 74% of the company. ',
    ],
    abouts: [
      "Musk, who says he's worried about population collapse, has nine children with three women including triplets and two sets of twins.",
      'As a kid in South Africa, Musk taught himself to code; he sold his first game, Blastar, for about $500.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'jeff-bezos',
    bio: '',
    rank: 3,
    listUri: 'rtb',
    finalWorth: 125813.245,
    person: {
      name: 'Jeff Bezos',
      uri: 'jeff-bezos',
      imageExists: true,
      squareImage:
        'https://specials-images.forbesimg.com/imageserve/5bb22ae84bbe6f67d2e82e05/416x416.jpg?background=000000&cropX1=627&cropX2=1639&cropY1=129&cropY2=1142',
    },
    visible: true,
    personName: 'Jeff Bezos',
    state: 'Washington',
    city: 'Medina',
    source: 'Amazon',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734429,
    naturalId: 'faris/35/0/6713',
    position: 3,
    imageExists: true,
    gender: 'M',
    birthDate: -188438400000,
    lastName: 'Bezos',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'AMZN-US',
        companyName: 'Amazon',
        numberOfShares: 991929000,
        sharePrice: 102.51,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 102.74,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 125585.10179,
    privateAssetsWorth: 23902.46,
    familyList: false,
    interactive: true,
    archivedWorth: 114000,
    thumbnail:
      'http://specials-images.forbesimg.com/imageserve/5bb22ae84bbe6f67d2e82e05/280x425.jpg?fit=scale&background=000000',
    squareImage:
      'https://specials-images.forbesimg.com/imageserve/5bb22ae84bbe6f67d2e82e05/416x416.jpg?background=000000&cropX1=627&cropX2=1639&cropY1=129&cropY2=1142',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Jeff Bezos founded e-commerce giant Amazon in 1994 out of his garage in Seattle. He stepped down as CEO to become executive chairman in July 2021.',
      'He now owns a bit less than 10% of the company.',
      'He and his wife MacKenzie divorced in 2019 after 25 years of marriage and he transferred a quarter of his then-16% Amazon stake to her.',
      "Bezos has donated more than $400 million worth of stock to nonprofits in 2022, though it's unclear which organizations received those shares.",
      'Bezos owns The Washington Post and Blue Origin, an aerospace company developing rockets; he briefly flew to space in one in July 2021.',
      'Bezos said in a November 2022 interview with CNN that he plans to give away the majority of his wealth in his lifetime, without disclosing specific details. ',
    ],
    abouts: [
      "Growing up, Jeff Bezos worked summers on his grandfather's ranch repairing Caterpillar tractors.",
      "Bezos met Google founders Larry Page and Sergey Brin in 1998 and managed to become one of the company's first angel investors, putting in an estimated $250,000.",
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'larry-ellison',
    bio: '',
    rank: 4,
    listUri: 'rtb',
    finalWorth: 120254.555,
    person: {
      name: 'Larry Ellison',
      uri: 'larry-ellison',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5e8b62cfc095010007bffea0/416x416.jpg?background=000000&cropX1=0&cropX2=4529&cropY1=652&cropY2=5184',
    },
    visible: true,
    personName: 'Larry Ellison',
    state: 'Hawaii',
    city: 'Lanai',
    source: 'Oracle',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734366,
    naturalId: 'faris/35/0/5574',
    position: 4,
    imageExists: true,
    gender: 'M',
    birthDate: -800755200000,
    lastName: 'Ellison',
    financialAssets: [
      {
        exchange: 'NYSE',
        ticker: 'ORCL-US',
        companyName: 'Oracle',
        numberOfShares: 1066000000,
        sharePrice: 95.71,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 95.59,
      },
      {
        exchange: 'NYSE',
        ticker: 'ORCL-US',
        companyName: 'Oracle',
        numberOfShares: 2250000,
        exerciseOptionPrice: 40.47,
        sharePrice: 95.71,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 95.59,
      },
      {
        exchange: 'NYSE',
        ticker: 'ORCL-US',
        companyName: 'Oracle',
        numberOfShares: 7000000,
        exerciseOptionPrice: 30.11,
        sharePrice: 95.71,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 95.59,
      },
      {
        exchange: 'NYSE',
        ticker: 'ORCL-US',
        companyName: 'Oracle',
        numberOfShares: 2500000,
        exerciseOptionPrice: 51.13,
        sharePrice: 95.71,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 95.59,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 45018750,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 750000,
        exerciseOptionPrice: 14.982666666666667,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'TSLA-US',
        companyName: 'Tesla',
        numberOfShares: 125010.00000000001,
        exerciseOptionPrice: 22.33,
        sharePrice: 185,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 187.04,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 120290.261295,
    privateAssetsWorth: 9092.144168,
    familyList: false,
    interactive: true,
    archivedWorth: 107000,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5e8b62cfc095010007bffea0/416x416.jpg?background=000000&cropX1=0&cropX2=4529&cropY1=652&cropY2=5184',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Larry Ellison is chairman, chief technology officer and cofounder of software giant Oracle, of which he owns about 35%.',
      'He gave up the Oracle CEO role in 2014 after 37 years at the helm.',
      'Oracle has grown in part through steady acquisitions of software companies: the biggest was $28.3 billion for electronic health records company Cerner in 2021.',
      'In 2020, Ellison moved permanently to  the Hawaiian island Lanai, which he bought nearly all of in 2012 for $300 million.',
      "Ellison sat on Tesla's board from December 2018 to August 2022. He still owns about 15 million shares in the electric carmaker.",
    ],
    abouts: [
      'Ellison never finished college. He started out building databases for the CIA.',
      'Daughter Megan has financed films such as Zero Dark Thirty and American Hustle; son David produced mainstream movies like The Terminator and Mission: Impossible.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'warren-buffett',
    bio: '',
    rank: 5,
    listUri: 'rtb',
    finalWorth: 114188.859,
    person: {
      name: 'Warren Buffett',
      uri: 'warren-buffett',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5babb7f1a7ea4342a948b79a/416x416.jpg?background=000000&cropX1=748&cropX2=3075&cropY1=1753&cropY2=4082',
    },
    visible: true,
    personName: 'Warren Buffett',
    state: 'Nebraska',
    city: 'Omaha',
    source: 'Berkshire Hathaway',
    industries: ['Finance & Investments'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734371,
    naturalId: 'faris/35/0/5381',
    position: 5,
    imageExists: true,
    gender: 'M',
    birthDate: -1241481600000,
    lastName: 'Buffett',
    financialAssets: [
      {
        exchange: 'NYSE',
        ticker: 'BRK.A-US',
        companyName: 'Berkshire Hathaway Inc. (Cl A)',
        numberOfShares: 227416,
        sharePrice: 496000,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 497900,
      },
      {
        exchange: 'NYSE',
        ticker: 'BRK.B-US',
        companyName: 'Berkshire Hathaway Inc. (Cl B)',
        numberOfShares: 276,
        sharePrice: 319.74,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 323.79,
      },
      {
        exchange: 'NYSE',
        ticker: 'USB-US',
        companyName: 'U.S. Bancorp',
        numberOfShares: 684000,
        sharePrice: 34.97,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 35.59,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 113756.343728,
    privateAssetsWorth: 934,
    familyList: false,
    interactive: true,
    archivedWorth: 106000,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5babb7f1a7ea4342a948b79a/416x416.jpg?background=000000&cropX1=748&cropX2=3075&cropY1=1753&cropY2=4082',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Known as the "Oracle of Omaha," Warren Buffett is one of the most successful investors of all time.',
      'Buffett runs Berkshire Hathaway, which owns dozens of companies, including insurer Geico, battery maker Duracell and restaurant chain Dairy Queen.',
      'The son of a U.S. congressman, he first bought stock at age 11 and first filed taxes at age 13.',
      "He has promised to donate over 99% of his wealth. So far he has given more than $49 billion, mostly to the Gates Foundation and his kids' foundations.",
      'In 2010, he and Bill Gates launched the Giving Pledge, asking billionaires to commit to donating at least half of their wealth to charitable causes.',
    ],
    abouts: [
      'Buffett still lives in the same Omaha, Nebraska, home he purchased in 1958 for $31,500.',
      "Buffett was rejected from Harvard Business School; he got a master's in economics from Columbia University instead.",
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'bill-gates',
    bio: '',
    rank: 6,
    listUri: 'rtb',
    finalWorth: 110640.913,
    person: {
      name: 'Bill Gates',
      uri: 'bill-gates',
      imageExists: true,
      squareImage:
        'https://specials-images.forbesimg.com/imageserve/62d599ede3ff49f348f9b9b4/416x416.jpg?background=000000&cropX1=155&cropX2=976&cropY1=340&cropY2=1161',
    },
    visible: true,
    personName: 'Bill Gates',
    state: 'Washington',
    city: 'Medina',
    source: 'Microsoft',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734478,
    naturalId: 'faris/35/0/5772',
    position: 6,
    imageExists: true,
    gender: 'M',
    birthDate: -447465600000,
    lastName: 'Gates',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'ACGL-US',
        companyName: 'Arch Capital Group',
        numberOfShares: 0,
        sharePrice: 70.25,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 70.95,
      },
      {
        exchange: 'NYSE',
        ticker: 'ARCO-US',
        companyName: 'Arcos Dorados Holdings Inc',
        numberOfShares: 0,
        sharePrice: 7.72,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 8.08,
      },
      {
        exchange: 'NYSE',
        ticker: 'AN-US',
        companyName: 'AutoNation Inc.',
        numberOfShares: 9871000,
        sharePrice: 134.9,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 134.64,
      },
      {
        exchange: 'NYSE',
        ticker: 'BRK.A-US',
        companyName: 'Berkshire Hathaway Inc. (Cl A)',
        numberOfShares: 4350,
        sharePrice: 496000,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 497900,
      },
      {
        exchange: 'NYSE',
        ticker: 'CNI-US',
        companyName: 'Canadian National Railway Co.',
        numberOfShares: 9534000,
        sharePrice: 122.38,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 122.41,
      },
      {
        exchange: 'NYSE',
        ticker: 'KOF-US',
        companyName: 'Coca-Cola FEMSA S.A.B de C.V.',
        numberOfShares: 0,
        sharePrice: 83.64,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 83.51,
      },
      {
        exchange: 'NYSE',
        ticker: 'DE-US',
        companyName: 'Deere & Co',
        numberOfShares: 19771000,
        sharePrice: 387.77,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 391.42,
      },
      {
        exchange: 'NYSE',
        ticker: 'ECL-US',
        companyName: 'Ecolab',
        numberOfShares: 31185500,
        sharePrice: 164.37,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 163.95,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'EVLV-US',
        companyName: 'Evolv Technologies Holdings',
        numberOfShares: 15050000,
        sharePrice: 3.06,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 3.05,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'XCUR-US',
        companyName: 'Exicure',
        numberOfShares: 209000,
        sharePrice: 1.02,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 1.03,
      },
      {
        exchange: 'MADRID',
        ticker: 'FCC-ES',
        companyName: 'Fomento de Construcciones y Contrata',
        numberOfShares: 10707368,
        sharePrice: 10.016510731975783,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
        currentPrice: 9.906439185470557,
      },
      {
        exchange: 'NYSE',
        ticker: 'FMX-US',
        companyName: 'Fomento Economico Mex-SP ADR',
        numberOfShares: 10810000,
        sharePrice: 93.35,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 93.26,
      },
      {
        exchange: 'NYSE',
        ticker: 'DNA-US',
        companyName: 'Ginkgo Bioworks Holdings',
        numberOfShares: 139900000,
        sharePrice: 1.3,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 1.22,
      },
      {
        exchange: 'SIX SWISS',
        ticker: 'GIVN-CH',
        companyName: 'Givaudan S.A.',
        numberOfShares: 1030999.9999999999,
        sharePrice: 3454.52511466607,
        currencyCode: 'CHF',
        exchangeRate: 0.8939,
        interactive: false,
        currentPrice: 3446.6942611030317,
      },
      {
        exchange: 'MEXICO',
        ticker: 'TLEVISACPO-MX',
        companyName: 'Grupo Televisa S.A.B Unit Class A (TLEVISACPO-MX)',
        numberOfShares: 0,
        sharePrice: 1.0762679055361983,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
        currentPrice: 1.066312703943366,
      },
      {
        exchange: 'EURONEXT AMSTERDAM',
        ticker: 'HEIO-NL',
        companyName: 'Heineken Holding',
        numberOfShares: 6650000,
        sharePrice: 95.37699504678042,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
        currentPrice: 94.66152999449642,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'MSFT-US',
        companyName: 'Microsoft',
        numberOfShares: 102992000,
        sharePrice: 286.14,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 288.8,
      },
      {
        exchange: 'EURONEXT AMSTERDAM',
        ticker: 'OCI-NL',
        companyName: 'OCI NV',
        numberOfShares: 0,
        sharePrice: 32.95542102366539,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
        currentPrice: 33.880022014309304,
      },
      {
        exchange: 'EGYPT',
        ticker: 'OCIC-EG',
        companyName: 'Orascom Construction Industries S.A.',
        numberOfShares: 0,
        sharePrice: 7.037864077669903,
        currencyCode: 'EGP',
        exchangeRate: 30.9,
        interactive: false,
        currentPrice: 7.037864077669903,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'OTTR-US',
        companyName: 'Otter Tail Corp.',
        numberOfShares: 3456000,
        sharePrice: 73.68,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 73.11,
      },
      {
        exchange: 'NYSE',
        ticker: 'RSG-US',
        companyName: 'Republic Services',
        numberOfShares: 109812000,
        sharePrice: 137.37,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 138.67,
      },
      {
        exchange: 'LONDON',
        ticker: 'SIG-GB',
        companyName: 'Signature Aviation Plc',
        numberOfShares: 142395000,
        sharePrice: 4.927824788451966,
        currencyCode: 'GBP',
        exchangeRate: 0.8036,
        interactive: false,
        currentPrice: 4.927824788451966,
      },
      {
        exchange: 'SIX SWISS',
        ticker: 'SIKA-CH',
        companyName: 'Sika',
        numberOfShares: 4073000.0000000005,
        sharePrice: 270.38818659805344,
        currencyCode: 'CHF',
        exchangeRate: 0.8939,
        interactive: false,
        currentPrice: 269.71697057836445,
      },
      {
        exchange: 'NYSE',
        ticker: 'BEE-US',
        companyName: 'Strategic Hotels & Resorts, Inc.',
        numberOfShares: 13240000,
        sharePrice: 0,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 0,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'VRM-US',
        companyName: 'Vroom',
        numberOfShares: 0,
        sharePrice: 0.919,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 0.9119,
      },
      {
        exchange: 'NYSE',
        ticker: 'WM-US',
        companyName: 'Waste Management',
        numberOfShares: 16600000.000000002,
        sharePrice: 165.3,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 165.4,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 110188.514781,
    privateAssetsWorth: 37843,
    familyList: false,
    interactive: false,
    archivedWorth: 104000,
    thumbnail:
      'http://specials-images.forbesimg.com/imageserve/62d599ede3ff49f348f9b9b4/280x425.jpg?fit=scale&background=000000',
    squareImage:
      'https://specials-images.forbesimg.com/imageserve/62d599ede3ff49f348f9b9b4/416x416.jpg?background=000000&cropX1=155&cropX2=976&cropY1=340&cropY2=1161',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Bill Gates turned his fortune from software firm Microsoft into diversified holdings including investments in zero-carbon energy.',
      'In May 2021, Bill and Melinda Gates each announced on Twitter they were ending their marriage after 27 years. They still co-chair the charitable Gates Foundation.',
      'Gates, who cofounded Microsoft with Paul Allen (d. 2018) in 1975, transferred at least $6 billion worth of shares in public companies to Melinda as part of the divorce settlement. ',
      "As of March 2020, when Gates stepped down from the Microsoft board, he owned about 1.3% of the software and computing company's shares.",
      'He has invested in dozens of companies including Republic Services and Deere & Co., and is one of the largest owners of farmland in the U.S.',
      'To date, Gates has donated more than $59 billion to the Gates Foundation, including a $20 billion gift announced in July 2022. Most of his early donations were gifts of Microsoft stock.',
    ],
    abouts: [
      'When Gates was a kid, he spent so much time reading that his parents finally forbade him from bringing books to the dinner table.',
      'Gates took a break from classes his senior year in high school to do programming with his friend Paul Allen at a power plant in North Bonneville, Washington.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'carlos-slim-helu',
    bio: '',
    rank: 7,
    listUri: 'rtb',
    finalWorth: 96077.967,
    person: {
      name: 'Carlos Slim Helu & family',
      uri: 'carlos-slim-helu',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c76ba144bbe6f24ad99c613/416x416.jpg?background=000000&cropX1=0&cropX2=3005&cropY1=389&cropY2=3395',
    },
    visible: true,
    personName: 'Carlos Slim Helu & family',
    city: 'Mexico City',
    source: 'Telecom',
    industries: ['Telecom'],
    countryOfCitizenship: 'Mexico',
    timestamp: 1681767302142,
    version: 734386,
    naturalId: 'faris/35/0/4466',
    position: 7,
    imageExists: true,
    gender: 'M',
    birthDate: -944438400000,
    lastName: 'Slim Helu',
    financialAssets: [
      {
        exchange: 'NYSE',
        ticker: 'AMX-US',
        companyName: 'America Movil SAB de CV (ADR)',
        numberOfShares: 2343200000,
        sharePrice: 21.47,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
      },
      {
        exchange: 'MADRID',
        ticker: 'FCC-ES',
        companyName: 'Fomento de Construcciones y Contrata',
        numberOfShares: 345300000,
        sharePrice: 10.016510731975783,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'MEXICO',
        ticker: 'GCARSOA1-MX',
        companyName: 'Grupo Carso S.A.B. de C.V. (Series A',
        numberOfShares: 1809000000,
        sharePrice: 5.3232675183894695,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
      },
      {
        exchange: 'MEXICO',
        ticker: 'GFINBURO-MX',
        companyName: 'Grupo Financiero Inbursa S.A.B. de C',
        numberOfShares: 3853500000,
        sharePrice: 2.1558542116033403,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
      },
      {
        exchange: 'MEXICO',
        ticker: 'IDEALB.1-MX',
        companyName: 'Impulsora del Desarrollo y el Empleo',
        numberOfShares: 628390000,
        sharePrice: 2.0463469940821857,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
      },
      {
        exchange: 'LONDON',
        ticker: 'INM-GB',
        companyName: 'Independent News & Media PLC',
        numberOfShares: 5674048,
        sharePrice: 0.11337369290038525,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'MEXICO',
        ticker: 'INCARSOB.1-MX',
        companyName: 'Inmuebles Carso SAB de CV',
        numberOfShares: 0,
        sharePrice: 0,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
      },
      {
        exchange: 'MEXICO',
        ticker: 'MFRISCOA.1-MX',
        companyName: 'Minera Frisco SAB de CV',
        numberOfShares: 5138600000,
        sharePrice: 0.1526464244234279,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
      },
      {
        exchange: 'NYSE',
        ticker: 'NYT-US',
        companyName: 'New York Times Co.',
        numberOfShares: 0,
        sharePrice: 39.88,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
      },
      {
        exchange: 'NYSE',
        ticker: 'PBF-US',
        companyName: 'PBF Energy Inc  (PBF)',
        numberOfShares: 1200000,
        sharePrice: 38.64,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
      },
      {
        exchange: 'MADRID',
        ticker: 'PRS-ES',
        companyName: 'Promotora de Informaciones S.A.',
        numberOfShares: 933331,
        sharePrice: 0.3940561364887177,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'MADRID',
        ticker: 'RLIA-ES',
        companyName: 'Realia Business',
        numberOfShares: 601500000,
        sharePrice: 1.1172261970280681,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'MEXICO',
        ticker: 'SITES1A.1-MX',
        companyName: 'Telesites SAB Class A',
        numberOfShares: 2960200000,
        sharePrice: 0.9717382888114596,
        currencyCode: 'MXN',
        exchangeRate: 18.081,
        interactive: false,
      },
      {
        exchange: 'NYSE',
        ticker: 'YPF-US',
        companyName: 'YPF',
        numberOfShares: 19975000,
        sharePrice: 12.45,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 95090.651,
    privateAssetsWorth: 17471.15873,
    familyList: false,
    interactive: false,
    archivedWorth: 93000,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c76ba144bbe6f24ad99c613/416x416.jpg?background=000000&cropX1=0&cropX2=3005&cropY1=389&cropY2=3395',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      "Mexico's richest man, Carlos Slim Helu and his family control América Móvil, Latin America's biggest mobile telecom firm.",
      "With foreign telecom partners, Slim bought a stake in Telmex, Mexico's only phone company, in 1990. Telmex is now part of América Móvil.",
      'He also owns stakes in Mexican construction, consumer goods, mining and real estate companies. He used to own 17% of The New York Times, but sold it.',
      "His son-in-law Fernando Romero designed the Soumaya Museum in Mexico City, home to Slim's extensive, eclectic art collection.",
      "Slim and his family hold a 79% stake of Grupo Carso, one of Latin America's largest conglomerates, accounting for over 8% of his fortune.",
    ],
    abouts: [
      'Every Sunday his father would give Carlos a 5-peso allowance, requiring him to record his purchases in a ledger.',
      'Before going into business, Slim taught algebra at UNAM, a university in Mexico City.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'michael-bloomberg',
    bio: '',
    rank: 8,
    listUri: 'rtb',
    finalWorth: 94456,
    person: {
      name: 'Michael Bloomberg',
      uri: 'michael-bloomberg',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c76b4104bbe6f24ad99c35d/416x416.jpg?background=000000&cropX1=165&cropX2=5613&cropY1=321&cropY2=5769',
    },
    visible: true,
    personName: 'Michael Bloomberg',
    state: 'New York',
    city: 'New York',
    source: 'Bloomberg LP',
    industries: ['Media & Entertainment'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734384,
    naturalId: 'faris/35/0/5640',
    position: 8,
    imageExists: true,
    gender: 'M',
    birthDate: -879811200000,
    lastName: 'Bloomberg',
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 94456,
    privateAssetsWorth: 94456,
    familyList: false,
    interactive: false,
    archivedWorth: 94500,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c76b4104bbe6f24ad99c35d/416x416.jpg?background=000000&cropX1=165&cropX2=5613&cropY1=321&cropY2=5769',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Michael Bloomberg cofounded financial information and media company Bloomberg LP in 1981.',
      'He put in the seed funding for the company and now owns 88% of the business, which has estimated revenues north of $12 billion.',
      'Bloomberg got his start on Wall Street in 1966 with an entry level job at investment bank Salomon Brothers. He was fired 15 years later.',
      'A major philanthropist, he has donated more than $12.7 billion to gun control, climate change and other causes.',
      'He announced a run for president in November 2019 (but dropped out in March 2020), and spent hundreds of millions to defeat Donald Trump in 2020.',
      'The mayor of New York City for 12 years, Bloomberg is one of just four individuals to have served that long.',
    ],
    abouts: [
      'In November 2018, Bloomberg pledged $1.8 billion to Johns Hopkins University, his undergraduate alma mater, adding to $1.5 billion he had already given the school.',
      'As a teenager, Bloomberg worked at an electronics company in Cambridge, MA.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'francoise-bettencourt-meyers',
    bio: '',
    rank: 9,
    listUri: 'rtb',
    finalWorth: 92977.293,
    person: {
      name: 'Francoise Bettencourt Meyers & family',
      uri: 'francoise-bettencourt-meyers',
      imageExists: false,
      squareImage:
        'https://specials-images.forbesimg.com/imageserve/605e26e3c65f7c2596bd3e15/416x416.jpg?background=000000&cropX1=0&cropX2=1080&cropY1=0&cropY2=1080',
    },
    visible: true,
    personName: 'Francoise Bettencourt Meyers & family',
    city: 'Paris',
    source: "L'Oréal",
    industries: ['Fashion & Retail'],
    countryOfCitizenship: 'France',
    timestamp: 1681767302142,
    version: 332998,
    naturalId: 'faris/35/0/203905',
    position: 9,
    imageExists: false,
    gender: 'F',
    birthDate: -520041600000,
    lastName: 'Bettencourt Meyers',
    financialAssets: [
      {
        exchange: 'EURONEXT PARIS',
        ticker: 'OR-FR',
        companyName: "L'Oreal S.A.",
        numberOfShares: 185705000,
        sharePrice: 463.01596037424326,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 92466.272151,
    privateAssetsWorth: 6481.89323,
    familyList: false,
    interactive: false,
    archivedWorth: 80500,
    squareImage:
      'https://specials-images.forbesimg.com/imageserve/605e26e3c65f7c2596bd3e15/416x416.jpg?background=000000&cropX1=0&cropX2=1080&cropY1=0&cropY2=1080',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      "Francoise Bettencourt Meyers, the granddaughter of the founder of L'Oreal, is the richest woman in the world.",
      "Bettencourt Meyers and her family own around 33% of L'Oreal stock.",
      "She has served on L'Oreal's board since 1997 and is chairwoman of the family holding company.",
      "She became France's reigning L'Oreal heiress in 2017 when her mother Liliane Bettencourt, then the world's richest woman, died at age 94.",
      "Bettencourt Meyers also serves as the president of her family's philanthropic foundation, which encourages French progress in the sciences and arts.",
      "Together, L'Oreal and the Bettencourt Meyers family agreed to donate $226 million to repair Notre Dame Cathedral following the April 2019 fire.",
    ],
    abouts: [
      "Bettencourt Meyers' inheritance was the subject of a sensational trial in France, in which a man was convicted of manipulating her ailing mother for her fortune.",
      'Bettencourt Meyers is also a writer and has authored a book on the Greek gods and another with commentary on the Bible.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'larry-page',
    bio: '',
    rank: 10,
    listUri: 'rtb',
    finalWorth: 91147.614,
    person: {
      name: 'Larry Page',
      uri: 'larry-page',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c76bcaaa7ea43100043c836/416x416.jpg?background=000000&cropX1=227&cropX2=2022&cropY1=22&cropY2=1817',
    },
    visible: true,
    personName: 'Larry Page',
    state: 'California',
    city: 'Palo Alto',
    source: 'Google',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734374,
    naturalId: 'faris/35/0/7441',
    position: 10,
    imageExists: true,
    gender: 'M',
    birthDate: 101952000000,
    lastName: 'Page',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'GOOGL-US',
        companyName: 'Alphabet',
        numberOfShares: 389051160,
        sharePrice: 108.87,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 105.97,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'GOOG-US',
        companyName: 'Google Inc. (Cl C)',
        numberOfShares: 390272280,
        sharePrice: 109.46,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 106.42,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 93462.289877,
    privateAssetsWorth: 8387.086319,
    familyList: false,
    interactive: true,
    archivedWorth: 79200,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c76bcaaa7ea43100043c836/416x416.jpg?background=000000&cropX1=227&cropX2=2022&cropY1=22&cropY2=1817',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Larry Page stepped down as CEO of Alphabet, the parent of Google, in December 2019 but remains a board member and a controlling shareholder.',
      'He cofounded Google in 1998 with fellow Stanford Ph.D. student Sergey Brin.',
      "With Brin, Page invented Google's PageRank algorithm, which powers the search engine.",
      "Page was CEO until 2001, when Eric Schmidt took over, and then from 2011 until 2015, when he became CEO of Google's new parent company Alphabet.",
      'He is a founding investor in space exploration company Planetary Resources and is also funding "flying car" startups Kitty Hawk and Opener.',
    ],
    abouts: [
      "Page has avoided public appearances since Sundar Pichai became Google's CEO, including Alphabet's 2019 shareholders meeting -- much to investors' chagrin.",
      'Page is a clean energy advocate; his Palo Alto home uses fuel cells and geothermal energy.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'steve-ballmer',
    bio: '',
    rank: 11,
    listUri: 'rtb',
    finalWorth: 90899.028,
    person: {
      name: 'Steve Ballmer',
      uri: 'steve-ballmer',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/59d50c47a7ea436b47b36d66/416x416.jpg?background=000000&cropX1=553&cropX2=2940&cropY1=322&cropY2=2708',
    },
    visible: true,
    personName: 'Steve Ballmer',
    state: 'Washington',
    city: 'Hunts Point',
    source: 'Microsoft',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734398,
    naturalId: 'faris/35/0/5671',
    position: 11,
    imageExists: true,
    gender: 'M',
    birthDate: -434678400000,
    lastName: 'Ballmer',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'MSFT-US',
        companyName: 'Microsoft',
        numberOfShares: 252843075,
        sharePrice: 286.14,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
      },
      {
        exchange: 'NYSE',
        ticker: 'TWTR-US',
        companyName: 'Twitter, Inc.',
        numberOfShares: 0,
        sharePrice: 53.7,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 90226.465007,
    privateAssetsWorth: 17877.947527,
    familyList: false,
    interactive: false,
    archivedWorth: 80700,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/59d50c47a7ea436b47b36d66/416x416.jpg?background=000000&cropX1=553&cropX2=2940&cropY1=322&cropY2=2708',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Steve Ballmer is the high-wattage former CEO of Microsoft, who led the company from 2000 to 2014.',
      "He joined Microsoft in 1980 as employee No. 30 after dropping out of Stanford's MBA program.",
      'Ballmer oversaw Microsoft after the first dot-com crash and through efforts to catch up to Google in search capabilities and Apple in mobile phones.',
      "The same year he retired from Microsoft he bought the NBA's Los Angeles Clippers for $2 billion.",
      'He has ramped up his philanthropy since 2014, putting over $2 billion into a donor-advised fund, with a focus on economic mobility.',
      'In 2022, he and his wife Connie donated some $425 million to the University of Oregon to create an institute aimed at the behavioral and mental health needs of children in the state.',
    ],
    abouts: [
      'Ballmer and Microsoft cofounder Bill Gates were classmates at Harvard.',
      'Ballmer created a website called USAFacts.org for people to look up and understand where the government is spending money.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'sergey-brin',
    bio: '',
    rank: 12,
    listUri: 'rtb',
    finalWorth: 87297.131,
    person: {
      name: 'Sergey Brin',
      uri: 'sergey-brin',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c7d7c254bbe6f78090d831f/416x416.jpg?background=000000&cropX1=475&cropX2=2887&cropY1=168&cropY2=2582',
    },
    visible: true,
    personName: 'Sergey Brin',
    state: 'California',
    city: 'Los Altos',
    source: 'Google',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734389,
    naturalId: 'faris/35/0/7442',
    position: 12,
    imageExists: true,
    gender: 'M',
    birthDate: 114739200000,
    lastName: 'Brin',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'GOOGL-US',
        companyName: 'Alphabet',
        numberOfShares: 368367000,
        sharePrice: 108.87,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: false,
        currentPrice: 105.97,
      },
      {
        exchange: 'NASDAQ',
        ticker: 'GOOG-US',
        companyName: 'Google Inc. (Cl C)',
        numberOfShares: 369569000,
        sharePrice: 109.46,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 106.42,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 89488.884673,
    privateAssetsWorth: 8931.746643,
    familyList: false,
    interactive: true,
    archivedWorth: 76000,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c7d7c254bbe6f78090d831f/416x416.jpg?background=000000&cropX1=475&cropX2=2887&cropY1=168&cropY2=2582',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Sergey Brin stepped down as president of Alphabet, parent company of Google, in December 2019 but remains a controller shareholder and a board member.',
      'Brin moved to the U.S. from Russia when he was 6 years old in the wake of anti-Semitism against his family.',
      'He cofounded Google with Larry Page in 1998 after the two met at Stanford University while studying for advanced degrees in computer science.',
      'Google went public in 2004 and began trading as Alphabet, a newly created parent company, in 2015.',
      'Brin is reportedly funding a high-tech airship project.',
    ],
    abouts: [
      "The richest immigrant in America, Brin has been an outspoken critic of Trump's immigration ban.",
      'Brin moved to the U.S. from Russia when he was 6 years old in the wake of anti-Semitism against his family.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'mukesh-ambani',
    bio: '',
    rank: 13,
    listUri: 'rtb',
    finalWorth: 85114.228,
    person: {
      name: 'Mukesh Ambani',
      uri: 'mukesh-ambani',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c7d7829a7ea434b351ba0b6/416x416.jpg?background=000000&cropX1=206&cropX2=2043&cropY1=250&cropY2=2089',
    },
    visible: true,
    personName: 'Mukesh Ambani',
    city: 'Mumbai',
    source: 'Diversified',
    industries: ['Diversified'],
    countryOfCitizenship: 'India',
    timestamp: 1681767302142,
    version: 734400,
    naturalId: 'faris/35/0/7409',
    position: 13,
    imageExists: true,
    gender: 'M',
    birthDate: -400896000000,
    lastName: 'Ambani',
    financialAssets: [
      {
        exchange: 'BSE INDIA',
        ticker: '500325-IN',
        companyName: 'Reliance Industries Ltd.',
        numberOfShares: 2845255000,
        sharePrice: 28.77699160017005,
        currencyCode: 'INR',
        exchangeRate: 81.8588,
        interactive: false,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 84726.674965,
    privateAssetsWorth: 2848.79573,
    familyList: false,
    interactive: false,
    archivedWorth: 83400,
    thumbnail:
      'http://specials-images.forbesimg.com/imageserve/5c7d7829a7ea434b351ba0b6/280x425.jpg?fit=scale&background=000000',
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c7d7829a7ea434b351ba0b6/416x416.jpg?background=000000&cropX1=206&cropX2=2043&cropY1=250&cropY2=2089',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Mukesh Ambani chairs and runs $104 billion (revenue) Reliance Industries, which has interests in petrochemicals, oil and gas, telecom and retail.',
      "Reliance was founded by his late father Dhirubhai Ambani, a yarn trader, in 1966 as a small textile manufacturer. After his father's death in 2002, Ambani and his younger sibling Anil divvied up the family empire.",
      'Reliance sparked a telecom price war with the launch of 4G phone and broadband service Jio in 2016. Today, it has more than 430 million subscribers and is rapidly rolling out 5G services.',
      'Ambani is pivoting Reliance into green energy. The company will be investing $80 billion over the next 10-15 years on renewable energy and building a new complex next to its refinery.',
      'Ambani has spelled out his succession plan: son Akash is now chairman of Reliance Jio; daughter Isha oversees retail and younger son Anant has been inducted into the new energy business.',
    ],
    abouts: [
      'During the Covid-19 lockdown, Ambani raised more than $20 billion selling a third of Jio to a string of investors, such as Facebook and Google.',
      'Reliance owns Network18, a licensee of Forbes Media.',
      "Ambani's U.S.-educated daughter Isha's marriage to fellow billionaire Ajay Piramal's son in December 2018 drew 10,000 guests, including Hillary Clinton.",
      'Reliance Industries bought the Mandarin Oriental hotel in New York for $98 million.',
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'amancio-ortega',
    bio: '',
    rank: 14,
    listUri: 'rtb',
    finalWorth: 84114.938,
    person: {
      name: 'Amancio Ortega',
      uri: 'amancio-ortega',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c76b94131358e35dd27748e/416x416.jpg?background=000000&cropX1=179&cropX2=2232&cropY1=216&cropY2=2269',
    },
    visible: true,
    personName: 'Amancio Ortega',
    city: 'La Coruna',
    source: 'Zara',
    industries: ['Fashion & Retail'],
    countryOfCitizenship: 'Spain',
    timestamp: 1681767302142,
    version: 734356,
    naturalId: 'faris/35/0/7034',
    position: 14,
    imageExists: true,
    gender: 'M',
    birthDate: -1065484800000,
    lastName: 'Ortega',
    financialAssets: [
      {
        exchange: 'MADRID',
        ticker: 'SAN-ES',
        companyName: 'Banco Santander',
        numberOfShares: 21830000,
        sharePrice: 3.9746835443037978,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'MADRID',
        ticker: 'ENG-ES',
        companyName: 'Enagas',
        numberOfShares: 13100000,
        sharePrice: 19.774353329664283,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'MADRID',
        ticker: 'ITX-ES',
        companyName: 'Industria de Diseno Textil S.A.',
        numberOfShares: 1848000000,
        sharePrice: 34.221243808475506,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        companyName: 'Red Electrica Corp SA',
        numberOfShares: 27054000,
        sharePrice: 19.207484865162357,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
      {
        exchange: 'EURONEXT LISBON',
        ticker: 'RENE-PT',
        companyName: 'Redes Energeticas Nacionais',
        numberOfShares: 80100000,
        sharePrice: 2.922399559713814,
        currencyCode: 'EUR',
        exchangeRate: 0.9085,
        interactive: false,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 83341.494145,
    privateAssetsWorth: 19001.100715,
    familyList: false,
    interactive: false,
    archivedWorth: 77300,
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c76b94131358e35dd27748e/416x416.jpg?background=000000&cropX1=179&cropX2=2232&cropY1=216&cropY2=2269',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Amancio Ortega of Spain is one of the wealthiest clothing retailers in the world.',
      'A pioneer in fast fashion, he cofounded Inditex, known for its Zara fashion chain, with his ex-wife Rosalia Mera (d. 2013) in 1975.',
      'He owns about 60% of Madrid-listed Inditex, which has 8 brands, including Massimo Dutti and Pull & Bear, and 7,500 stores around the world.',
      'Ortega typically earns more than $400 million in dividends a year. In November 2021, Inditex announced that his daughter Marta Ortega Pérez will become chairperson in April 2022.',
      'He has invested his dividends primarily into real estate in Madrid, Barcelona, London, Chicago, Miami and New York.',
    ],
    abouts: [
      'Ortega first began his career manufacturing textiles through a small family company in 1963.',
      "He owns a 10% stake in Spanish telecoms firm Telxius and 5% of publicly traded natural gas grid operator Enag's.",
    ],
  },
  {
    name: 'Real-Time Billionaires',
    year: 0,
    uri: 'mark-zuckerberg',
    bio: '',
    rank: 15,
    listUri: 'rtb',
    finalWorth: 78082.592,
    person: {
      name: 'Mark Zuckerberg',
      uri: 'mark-zuckerberg',
      imageExists: true,
      squareImage:
        '//specials-images.forbesimg.com/imageserve/5c76b7d331358e35dd2773a9/416x416.jpg?background=000000&cropX1=0&cropX2=4401&cropY1=0&cropY2=4401',
    },
    visible: true,
    personName: 'Mark Zuckerberg',
    state: 'California',
    city: 'Palo Alto',
    source: 'Facebook',
    industries: ['Technology'],
    countryOfCitizenship: 'United States',
    timestamp: 1681767302142,
    version: 734379,
    naturalId: 'faris/35/0/8047',
    position: 15,
    imageExists: true,
    gender: 'M',
    birthDate: 453340800000,
    lastName: 'Zuckerberg',
    financialAssets: [
      {
        exchange: 'NASDAQ',
        ticker: 'META-US',
        companyName: 'Meta Platforms',
        numberOfShares: 348070000,
        sharePrice: 221.49,
        currencyCode: 'USD',
        exchangeRate: 1,
        interactive: true,
        currentPrice: 218.86,
      },
    ],
    date: 725846400000,
    wealthList: false,
    estWorthPrev: 78998.01632,
    privateAssetsWorth: 1903.99202,
    familyList: false,
    interactive: true,
    archivedWorth: 64400,
    thumbnail:
      'http://specials-images.forbesimg.com/imageserve/5c76b7d331358e35dd2773a9/280x425.jpg?fit=scale&background=000000',
    squareImage:
      '//specials-images.forbesimg.com/imageserve/5c76b7d331358e35dd2773a9/416x416.jpg?background=000000&cropX1=0&cropX2=4401&cropY1=0&cropY2=4401',
    bioSuppress: false,
    csfDisplayFields: [
      'rank',
      'age',
      'source',
      'finalWorth',
      'personName',
      'bios',
      'bio',
      'countryOfCitizenship',
    ],
    bios: [
      'Zuckerberg started Facebook at Harvard in 2004 at the age of 19 for students to match names with photos of classmates.',
      "He took Facebook public in May 2012; he now owns about 13% of the company's stock.",
      "Facebook changed its name to Meta in November 2021 to shift the company's focus to the metaverse.",
      'In June 2021, a judge dismissed antitrust cases brought by states and the federal government, which could have forced Facebook to sell off Instagram and WhatsApp.',
      'In December 2015, Zuckerberg and his wife, Priscilla Chan, pledged to give away 99% of their Facebook stake over their lifetimes.',
    ],
    abouts: [
      'Zuckerberg and his wife, Priscilla Chan, are spending $3 billion in an attempt to end, cure or manage all disease by the year 2100.',
      'In January 2019, Mark Zuckerberg purchased $59 million worth of waterfront property on Lake Tahoe in California.',
    ],
  },
]
